import { Box, Grid } from "@material-ui/core";
import React from "react";
import { AddItemInputFields } from "./AddItemInputFields";
import { IAddInventoryItemNod } from "src/common/typings/nod-warehouse";
import { ContainerDetail, vehicleDetail, indexDetail } from "src/common/typings/warehouse";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
  containerdetail: (newContainer: ContainerDetail) => void;
  indexDetail: (newIndexDetail: indexDetail) => void;
  vehicleDetail: (newVehicleDetail: vehicleDetail) => void;
  inventory_Items: (items: IAddInventoryItemNod[]) => IAddInventoryItemNod[];
  itemToRemove: IAddInventoryItemNod | undefined;
  itemToEdit: IAddInventoryItemNod;
  isSaved?: boolean;
};

export function AddItemInput({
  containerdetail,
  indexDetail,
  vehicleDetail,
  inventory_Items,
  itemToRemove,
  itemToEdit,
  isSaved,
}: Props): React.ReactElement {
  return (
    <>
      <Box borderColor="grey.200">
        <Grid container direction="row">
          <Grid item xs={12} md={12}>
            {/* Conent Start */}
            <AddItemInputFields
              isSaved={isSaved}
              containerDetail={containerdetail}
              index_Detail={indexDetail}
              vehicleDetail={vehicleDetail}
              inventory_Items={inventory_Items}
              itemToRemove={itemToRemove}
              itemToEdit={itemToEdit}
            />
            {/* Conent End */}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
